import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type { PosApi } from '..';
import type { Pos } from '../..';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayPosApi implements PosApi {
  client: ScpClient;
  host: string;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  getPos() {
    return this.makeRequest<Pos[]>({
      method: 'find-all-by-employee-id',
      payload: { withInactive: true },
    }).then((response) => response.payload);
  }

  private makeRequest<T>(params: Partial<RequestParams> & { method: string }) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/point-of-sales',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
